"use strict";
//
// Bitiotic ErrorInjector
//
// Set "BITIOTIC_INJECT_ERROR" environment variable to a 'key' and code checks with that
// key will throw an error.  Add code checks like:
//
//    errorInject.inject('startup');
//
// Or, to do more than throw a vanilla Error, provide a callback function:
//
//    errorInject.inject('asyncStartup', (msg: string): void => {
//        setTimeout(() => { throw new Error(msg); })
//    });
//
// Environment variable is checked once at startup, so setting the variable manually later
// will not trigger errors.
//
Object.defineProperty(exports, "__esModule", { value: true });
const errorInject_impl_1 = require("./errorInject-impl");
let inject = (_k, _i) => { };
const controlStr = (0, errorInject_impl_1.getEnv)('BITIOTIC_INJECT_ERROR');
if (controlStr !== undefined) {
    let controlKey = controlStr;
    let controlRate = 1.0;
    if (controlStr.includes(':')) {
        const controlParts = controlStr.split(':', 2);
        if (controlParts[0]) {
            controlKey = controlParts[0];
        }
        if (controlParts[1]) {
            let rate = Number(controlParts[1]);
            rate = Math.min(rate, 100);
            rate = Math.max(0, rate);
            controlRate = rate / 100.0;
        }
    }
    inject = (key, injector) => {
        if (controlKey === key && hit(controlRate)) {
            const msg = `Bitotic ErrorInjector: Injected '${key}' error`;
            if (injector) {
                injector(msg);
            }
            throw new Error(msg);
        }
    };
}
function hit(controlRate) {
    return Math.random() < controlRate;
}
exports.default = inject;
//# sourceMappingURL=errorInject.js.map